import { forwardRef } from "react";
import { ActionIcon, ActionIconProps } from "@mantine/core";
import { CONTROL_BUTTON_SETTINGS } from "config/constants";

export const ControlActionIcon = forwardRef<
  HTMLButtonElement,
  ActionIconProps & React.ComponentPropsWithoutRef<"button">
>(({ children, ...rest }, ref) => {
  return (
    <ActionIcon
      ref={ref}
      variant="transparent"
      sx={(theme, u) => ({
        [u.dark]: {
          "&:disabled": {
            color: theme.colors.dark[2],
          },
          color: theme.colors.dark[0],
        },
        [u.light]: {
          "&:disabled": {
            color: theme.colors.dark[0],
          },
          backgroundColor: "white",
          color: theme.colors.dark[7],
        },
        "&:disabled": { cursor: "default" },
      })}
      size={CONTROL_BUTTON_SETTINGS.size}
      {...rest}
    >
      {children}
    </ActionIcon>
  );
});
ControlActionIcon.displayName = "ControlActionIcon";
